/* ============================================================
   TEABO v5 — le panier est un TIROIR, jamais une page.

   Arbitrage Quentin du 13.08.2026 : « je ne veux pas de page Panier,
   je veux que ça ouvre le sidecart ».

   Le tiroir existait déjà (snippets/cart-drawer.liquid, l'élément
   personnalisé <cart-drawer> d'assets/cart-drawer.js, et les deux
   sections techniques cart-drawer / cart-icon-bubble pour l'API
   Section Rendering). Il est monté dans le layout depuis le début.
   Ce qui manquait, ce sont les APPELS : les bandes v5 postaient leur
   formulaire en pleine page, et Shopify répondait par /cart.

   UN SEUL écouteur délégué plutôt que six sections modifiées : toute
   bande v5 présente ou à venir qui poste vers /cart/add ouvre le
   tiroir sans avoir une ligne de JS à elle.

   CE QU'IL NE FAUT PAS DOUBLER — deux bandes ont déjà leur propre
   AJAX complet (la fiche produit teabo-v5-pdp-hero, et la carte v3
   teabo-card-product). Elles appellent `preventDefault()` sur des
   écouteurs posés plus bas dans l'arbre ou enregistrés plus tôt :
   `event.defaultPrevented` suffit donc à s'effacer devant elles.
   Un ajout compté deux fois est le bug le plus coûteux de la page,
   c'est ce test qui l'empêche — pas une liste de sélecteurs à tenir.

   REPLI — si le réseau tombe ou si <cart-drawer> est absent, on
   laisse l'envoi natif repartir : mieux vaut la page /cart que pas
   d'achat du tout. La page /cart reste donc en service comme filet
   (sans JS, lien direct, redirections Shopify) ; elle n'est
   simplement plus un passage obligé du parcours.
   ============================================================ */
(function () {
  'use strict';

  var SECTIONS = 'cart-drawer,cart-icon-bubble';

  function tiroir() {
    return document.querySelector('cart-drawer');
  }

  /* Chemin du panier, avec ou sans préfixe de langue (/fr/cart, /de-ch/cart). */
  function estCheminPanier(chemin) {
    return /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?cart\/?$/i.test(chemin);
  }

  /* Zone d'erreur discrète sous le bouton — style .teabo-atc-error,
     déjà défini dans cart-drawer.css. */
  function zoneErreur(form) {
    var e = form.querySelector('.teabo-atc-error');
    if (!e) {
      e = document.createElement('span');
      e.className = 'teabo-atc-error';
      e.setAttribute('role', 'status');
      form.appendChild(e);
    }
    return e;
  }

  /* ---------------------------------------------------------
     1. Ajout au panier — ouvre le tiroir au lieu de charger /cart
     --------------------------------------------------------- */
  document.addEventListener('submit', function (event) {
    /* Une bande qui gère déjà son ajout est passée avant nous. */
    if (event.defaultPrevented) return;

    var form = event.target;
    if (!form || form.tagName !== 'FORM' || !form.action) return;

    var chemin;
    try { chemin = new URL(form.action, location.href).pathname; } catch (e) { return; }
    /* UNIQUEMENT l'ajout. Le formulaire de mise à jour de la page /cart
       et le bouton « Passer commande » du tiroir pointent tous deux vers
       /cart : les intercepter casserait la commande. */
    if (!/\/cart\/add\/?$/i.test(chemin)) return;

    var boite = tiroir();
    if (!boite || typeof boite.renderContents !== 'function') return;

    event.preventDefault();
    if (form.dataset.teaboAdding === 'true') return;
    form.dataset.teaboAdding = 'true';

    /* FormData plutôt qu'un JSON reconstruit : la quantité, la variante
       choisie, les line item properties et le selling plan partent tels
       que le formulaire les porte, quelle que soit la bande. */
    var donnees = new FormData(form);
    donnees.append('sections', SECTIONS);
    donnees.append('sections_url', location.pathname);

    var bouton = form.querySelector('[type="submit"]');
    var erreur = zoneErreur(form);
    erreur.hidden = true;
    if (bouton) bouton.disabled = true;

    /* Pas de Content-Type explicite : le navigateur pose la frontière
       multipart lui-même, l'imposer casserait la requête. */
    var racine = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(racine + 'cart/add.js', {
      method: 'POST',
      body: donnees,
      headers: { Accept: 'application/json' }
    })
      .then(function (r) {
        return r.json().then(function (d) { return { ok: r.ok, data: d }; });
      })
      .then(function (res) {
        if (!res.ok) {
          /* Rupture de stock, quantité refusée… : Shopify décrit le refus,
             on l'affiche sur place plutôt que d'envoyer l'internaute ailleurs. */
          erreur.hidden = false;
          erreur.textContent = (res.data && (res.data.description || res.data.message))
            || 'Ajout impossible pour le moment.';
          return;
        }
        boite.renderContents({ sections: res.data.sections });
      })
      .catch(function () {
        // Ne pas rejouer un POST qui a peut-être déjà abouti côté Shopify.
        var message = 'Impossible de confirmer l’ajout. Vérifiez votre panier avant de réessayer.';
        erreur.textContent = message;
        var lien = document.createElement('a');
        lien.href = racine + 'cart';
        lien.textContent = ' Vérifier mon panier';
        erreur.appendChild(lien);
        erreur.hidden = false;
        if (typeof boite.refresh === 'function') {
          return boite.refresh().then(function () { boite.showError(message); }).catch(function () {});
        }
      })
      .finally(function () {
        delete form.dataset.teaboAdding;
        if (bouton) bouton.disabled = false;
      });
  });

  /* ---------------------------------------------------------
     2. Tout lien vers /cart ouvre le tiroir
     --------------------------------------------------------- */
  document.addEventListener('click', function (event) {
    if (event.defaultPrevented) return;
    /* Clic milieu, cmd/ctrl-clic, alt-clic : l'internaute demande
       explicitement une vraie navigation ou un téléchargement. On le
       laisse faire — c'est là que la page /cart garde son utilité. */
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    var lien = event.target && event.target.closest ? event.target.closest('a[href]') : null;
    if (!lien || lien.target === '_blank' || lien.hasAttribute('download')) return;

    var url;
    try { url = new URL(lien.href, location.href); } catch (e) { return; }
    if (url.origin !== location.origin || !estCheminPanier(url.pathname)) return;

    var boite = tiroir();
    if (!boite || typeof boite.open !== 'function') return;

    event.preventDefault();
    boite.open();
  });
})();
